import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { ReactComponent as QontactPointSVG } from '@assets/SVGs/QontactPoint/QontactPointSVG.svg';
import { TabDetailScreenWrapper } from '@components/General/TabDetailScreen';
import AgregarTurno from '@components/QontactPoints/TurnosV2/AgregarTurno';
import EditarTurno from '@components/QontactPoints/TurnosV2/EditarTurno';
import { useTurnos } from '@contexts/TurnosContext';
import { ColaboratorInfo } from '@models/Colaborators';
import { Application } from '@core/Application';
import { Flap } from '@models/Flap';
import { Organization } from '@models/Organization';
import { QontactPointInformation, ShiftRecipe, ShiftRecipeWithUserIDs } from '@models/QontactPoint';

interface TurnoScreenProps {
    org: Organization;
}

const TurnoScreen: React.FC<TurnoScreenProps> = ({org}) => {

    const location = useLocation();
    const { handleAdd, handleModify } = useTurnos();

    const [clickedScreen, setClickedScreen] = useState<string>(location.state?.defaultScreen || "editar")
    const [turno, setTurno] = useState<ShiftRecipe | null>(null);
    const [qontactPoint, setQontactPoint] = useState<QontactPointInformation | null>(null);
    const [colaboradores, setColaboradores] = useState<ColaboratorInfo[]>([]);

    let turnoRaw = location.state?.turno as ShiftRecipe;
    let qontactPointRaw = location.state?.qontactPoint as QontactPointInformation;

    const fetchNominaResponse = async () => {
        try {
            const usersService = Application.shared().coreDependencies.usersService;
            const json = await usersService.getNomina(org.id);
            console.log(json)

            setColaboradores(json.filter((colaborador: ColaboratorInfo) => !colaborador.deactivationTimestamp && colaborador.id))
        } catch (error) {
            console.error(error)
        }
    }


    useEffect(() => {
        console.log(turnoRaw);
        if (turnoRaw) {
            setTurno(turnoRaw);
        }
    }, [turnoRaw]);

    useEffect(() => {
        console.log(qontactPointRaw);
        if (qontactPointRaw) {
            setQontactPoint(qontactPointRaw);
        }
    }, [qontactPointRaw]);

    useEffect(() => {
        fetchNominaResponse();
    }, []);

    if (qontactPoint === null) {
        return <div></div>
    }



    const flaps: Flap[] = [
        { 
            id: 'editar', 
            label: 'Editar', 
            content: turno ? <EditarTurno onTurnoModified={handleModify} orgID={org.id} turnoRecipe={turno as ShiftRecipeWithUserIDs} colaboradores={colaboradores}/> 
                           : <AgregarTurno onTurnoAdded={handleAdd} orgID={org.id} buildingID={qontactPointRaw.buildingID} qontactPointID={qontactPointRaw.id} colaboradores={colaboradores} />
        }
    ];
    
    return (
        <TabDetailScreenWrapper
            title={turno ? turno.name : "Nuevo turno"}
            imgComponent={<QontactPointSVG />}
            flaps={flaps}
            flag={org.newFlags?.QontactPointCreationWeb}
            clickedScreen={clickedScreen}
            setClickedScreen={setClickedScreen}
        />
    );
    
};


export default TurnoScreen